<template>
  <div class="lrs_share">
      <div class ="img">
          <div class="info">
             <div class="img_header">
                 <img :src="avatar" alt="">
             </div>
            <div class="text">
                <p class="name"><span>{{username}}</span><span class="name_text">邀请你一起来玩游戏!</span></p>
                <span class="roomnum">房间号:{{lrsRoomId}}</span>
                <span class="password" v-show="(pwd && pwd !=='null' ? true : false)">密码:{{pwd}}</span>
            </div>
          </div>
      </div>
      <div class="btn" @click="share"></div>
    <Appopen
      :title="'我是谜app打开方式'"
      :browser="'1.点击右上角[...]'"
      :direct="'2. 选择[在浏览器中打开]'"
      :isAppopen="isAppopen"
      :num="'房间号:'+lrsRoomId"
    ></Appopen>
  </div>
</template>

<script>
import axios from 'axios'
import { appUrlAndroid, appUrlIOS } from "../../assets/js/base64";
export default {
    data(){
        return {
            avatar:'',
            username:'',
            lrsRoomId:'',
            pwd : '',
            isAppopen:false
        }
    },
    created(){
        document.getElementsByTagName('title')[0].innerText ="我是狼人"
        var u = navigator.userAgent,
        app = navigator.appVersion;
        this.isAndroid = u.indexOf("Android") > -1 || u.indexOf("Linux") > -1;
        this.isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
        this.userId = this.$route.query.id; 
        this.room = this.$route.query.num;
        this.pwd= this.$route.query.pwd ? this.$route.query.pwd  :''
        this.getShareInfo();
    },
     components:{
        Appopen: () => import("../../component/Appopen.vue")
    },
    methods:{
        getShareInfo(){
          axios
            .post(this.$interfaces.getLrsInfo, { userId: this.userId })
            .then(res => {
            let data = res.data.data ;
            this.avatar = data.user.avatar;
            this.username = data.user.nickname;
            this.lrsRoomId = data.roomId ? data.roomId : this.room;
            })
            .catch(err => {
            console.log(err);
            });
        },
       share() {
        this.baseUrl = "https://a.app.qq.com/o/simple.jsp?pkgname=com.wzf.fan";
        if (this.isAndroid) {
            window.location.href =
            this.baseUrl + `&android_schema=${appUrlAndroid("260000","roomId="+this.lrsRoomId)}`;
        } else if (this.isiOS) {
            let ua = navigator.userAgent.toLowerCase();
            if(ua.match(/QQ/i) == "qq"){
                this.isAppopen = true
            }else{
                window.location.href = appUrlIOS('260000',"roomId="+this.lrsRoomId);
            }
        }else{
                window.location.href = 'http://share.xiyacs.com/#/open'
        }
    },
    }
    
}
</script>
<style scoped>
@import '../../assets/css/base.css';
.lrs_share{
    width: 100vw;
    height: 100vh;
    position: relative;
}
.lrs_share .img{
    position: relative;
    background: url('../../assets/images/lrsimages/share/bg@2x.png')no-repeat;
    background-size:cover;
    width:17.75rem;
    height: 23.55rem;
    left:50%;
    transform: translateX(-50%);
    margin-top:2.75rem;
}
.lrs_share .img .info{
    position: absolute;
    top:19.3rem;
    display: flex;
    justify-content :space-between;
    align-items: center;
    height: 2.325rem;
    width:13.75rem;
    left:50%;
    transform: translateX(-50%);
}
.lrs_share .img .info .img_header {
    width: 2.475rem;
    height: 2.475rem;
    border-radius: 50%;
    overflow: hidden;
    margin-right:0.5rem;
    border:0.075rem solid rgba(147,104,213,1);
}
.lrs_share .img .info .img_header img{
    width:100%;
    height: 100%;
}
.lrs_share .img .info .text{
    font-size:0.75rem;
    width: 10.775rem;
    height: 2.475rem;
    font-family:"PingFang SC";
    font-weight:bold;
    color:rgba(118,74,186,1);
    display: inline-block;
    text-align: left; 
}
.lrs_share .img .info .text .name{
    padding-top:0.25rem;
    line-height:0.975rem;
    display: flex;
    justify-content:space-between;
    align-items:center; 
}
.lrs_share .img .info .text .name span{
    display: inline-block;
    text-align: center;
    width: 2.5rem;
    height: 100%;
     overflow: hidden;
    text-overflow:ellipsis;
    white-space: nowrap;
}
.lrs_share .img .info .text .name .name_text{
    text-align: left;
    flex: 1;
}
.lrs_share .img .info .text .roomnum,
.lrs_share .img .info .text .password{
    height:0.925rem;
    background:rgba(147,104,213,1);
    border-radius:0.25rem;
    font-size:0.55rem;
    font-family:"PingFang SC";
    font-weight:bold;
    color:rgba(255,255,255,1);
    line-height:0.925rem;
    padding-left:0.25rem;
    padding-right:0.25rem;  
    /* border:0.025rem solid green */
}
.lrs_share .img .info .text .password{
    margin-left:0.5rem;
}
.lrs_share .btn{
    position: relative;
    background: url('../../assets/images/lrsimages/share/join_btn@2x.png')no-repeat;
    background-size:cover;
    width:16.225rem;
    height: 3.225rem;
    left:50%;
    transform: translateX(-50%);
    margin-top:1.25rem
    
}
</style>


// WEBPACK FOOTER //
// src/components/lrs/lrs_share.vue